import createComponent, { ComponentProps } from '../utils/createComponent';
export type FooterProps = ComponentProps;

const Footer = createComponent({ name: 'Footer', componentAs: 'footer' });

export default Footer;
